<template>
  <footer
    id="MainFooter"
    class="relative w-full py-32 border-t-4 border-main-orange-color md:py-52"
  >
    <div class="absolute hidden top-20 right-20 md:block">
      <ScrollTopBtn />
    </div>
    <div
      v-if="footer_data != null"
      class="flex flex-wrap justify-between w-full max-w-screen-xl px-10 mx-auto xl:px-0"
    >
      <div class="w-full md:w-1/2 sm:w-1/3">
        <img
          alt="瑪吉斯 maxxis s98 logo"
          width="208"
          height="24"
          class="w-52 mb-14"
          src="/img/MAXXIS S98_B.png"
        />
        <h4 class="mb-5 text-2xl font-bold">
          {{ footer_data.company_name.content }}
        </h4>
        <p class="mb-2 text-sm font-semibold font-montserrat">
          TEL {{ footer_data.company_phone.content }}
        </p>
        <p class="text-sm font-semibold font-montserrat">
          FAX {{ footer_data.company_fax.content }}
        </p>
      </div>
      <div
        class="flex justify-between w-full mt-20 md:w-1/2 sm:w-2/3 md:pl-0 sm:pl-10 sm:mt-0 sm:justify-end"
      >
        <ol class="-mt-3 md:mr-28 sm:mr-14">
          <li class="py-3 text-sm font-semibold font-montserrat sm:text-base">
            <router-link to="/about"> ABOUT US </router-link>
          </li>
          <li class="py-3 text-sm font-semibold font-montserrat sm:text-base">
            <router-link to="/product_list/all"> BROWSE TIRES </router-link>
          </li>
          <li class="py-3 text-sm font-semibold font-montserrat sm:text-base">
            <router-link to="/compare"> COMPARE TIRES </router-link>
          </li>
          <li class="py-3 text-sm font-semibold font-montserrat sm:text-base">
            <router-link to="/news_list/all">NEWS</router-link>
          </li>
          <li class="py-3 text-sm font-semibold font-montserrat sm:text-base">
            <router-link to="/video_list">VIDEO</router-link>
          </li>
        </ol>
        <ol class="-mt-3">
          <li class="py-3 text-sm font-semibold sm:text-base font-montserrat">
            <router-link to="/dealers">FIND YOUR DEALER</router-link>
          </li>
          <li class="py-3 text-sm font-semibold sm:text-base font-montserrat">
            <router-link to="/contact_us">CONTACT US</router-link>
          </li>
          <li class="py-3 text-sm font-semibold sm:text-base font-montserrat">
            -
          </li>
          <li class="py-3 text-sm font-semibold sm:text-base font-montserrat">
            FOLLOW US
          </li>
          <li
            class="flex items-center py-3 text-sm font-semibold sm:text-base font-montserrat"
          >
            <a
              class="mr-4"
              :href="footer_data.company_facebook.content"
              target="_blank"
            >
              <i class="text-2xl icon-facebook"></i>
            </a>
            <a :href="footer_data.company_instagram.content" target="_blank"
              class="mr-4">
              <i class="text-2xl icon-instagram"></i>
            </a>
            <a
              :href="footer_data.company_tiktok.content"
              target="_blank"
            >
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 640" fill="CurrentColor" class="w-[21px] h-[24px]"><path d="M544.5 273.9C500.5 274 457.5 260.3 421.7 234.7L421.7 413.4C421.7 446.5 411.6 478.8 392.7 506C373.8 533.2 347.1 554 316.1 565.6C285.1 577.2 251.3 579.1 219.2 570.9C187.1 562.7 158.3 545 136.5 520.1C114.7 495.2 101.2 464.1 97.5 431.2C93.8 398.3 100.4 365.1 116.1 336C131.8 306.9 156.1 283.3 185.7 268.3C215.3 253.3 248.6 247.8 281.4 252.3L281.4 342.2C266.4 337.5 250.3 337.6 235.4 342.6C220.5 347.6 207.5 357.2 198.4 369.9C189.3 382.6 184.4 398 184.5 413.8C184.6 429.6 189.7 444.8 199 457.5C208.3 470.2 221.4 479.6 236.4 484.4C251.4 489.2 267.5 489.2 282.4 484.3C297.3 479.4 310.4 469.9 319.6 457.2C328.8 444.5 333.8 429.1 333.8 413.4L333.8 64L421.8 64C421.7 71.4 422.4 78.9 423.7 86.2C426.8 102.5 433.1 118.1 442.4 131.9C451.7 145.7 463.7 157.5 477.6 166.5C497.5 179.6 520.8 186.6 544.6 186.6L544.6 274z"/></svg>
            </a>
          </li>
        </ol>
      </div>
    </div>
  </footer>
</template>

<script>
import ScrollTopBtn from "@/components/ScrollTopBtn.vue";
export default {
  name: "MainFooter",
  components: {
    ScrollTopBtn,
  },
  computed: {
    footer_data() {
      return this.$store.state.footer_data;
    },
  },
  created() {
    if (this.footer_data == null) {
      this.$store.dispatch("getFooterData");
    }
  },
};
</script>
